/* ============================================================
   Warenkorb — Build 1: Versand-Bar + Sticky-Checkout live halten.
   Quelle der Wahrheit = /cart.js. Aktualisiert bei jeder Cart-Mutation (fetch + XHR abgefangen).
   Format garantiert €X,XX (symbolvoran, Komma-Dezimal) — konsistent, unabhängig vom Theme.
   ============================================================ */
(function () {
  if (window.__blCartInit) return; window.__blCartInit = 1; // Doppel-Init verhindern (Page + Drawer)
  var BL_EN = (document.documentElement.lang || '').slice(0, 2) === 'en' || /^\/en(\/|$)/.test(location.pathname); // i18n Cart-Drawer
  /* 23.09.2026: Preis kommt aus der Shopify-Währungsformatierung des Shops
     (Einstellungen > Allgemein > Währungsformatierung). Vorher war hier '€' fest
     vorangestellt — nach der Umstellung auf '19,90 €' passte das nicht mehr zum Rest
     des Shops. Fällt auf deutsche Schreibweise zurück, falls das Theme-Objekt fehlt. */
  function blMoney(cents) {
    cents = Math.max(0, Math.round(cents));
    try {
      var f = window.KROWN && KROWN.settings && KROWN.settings.shop_money_format;
      if (f && window.KROWN.helpers && KROWN.helpers.formatMoney) {
        return KROWN.helpers.formatMoney(cents, f).replace(/<[^>]*>/g, '');
      }
    } catch (e) {}
    var ev = Math.floor(cents / 100), c = cents % 100;
    return ev.toLocaleString('de-DE') + ',' + (c < 10 ? '0' : '') + c + ' \u20ac';
  }
  function euros(cents) { return blMoney(cents); }

  function updateFromCart(cart) {
    // Sticky-Total
    var stEls = document.querySelectorAll('[data-bl-sticky-total]');
    for (var i = 0; i < stEls.length; i++) stEls[i].textContent = euros(cart.total_price);
    var sticky = document.querySelector('[data-bl-sticky]');
    if (sticky) sticky.style.display = cart.item_count > 0 ? '' : 'none';

    // Warenkorb-Badge (oben rechts) synchron halten — sonst bleibt nach dem Löschen eine alte Zahl stehen
    var cnt = cart.item_count;
    var badges = document.querySelectorAll('[data-header-cart-count], [data-cart-count]');
    for (var bi = 0; bi < badges.length; bi++) {
      badges[bi].textContent = cnt;
      if (!badges[bi].classList.contains('hidden')) badges[bi].style.display = cnt > 0 ? '' : 'none'; // 0 -> Badge ausblenden
    }

    // PDP-Versandbar (Produktseite: custom-shipping_bar OHNE data-bl-ship) aus Live-Cart syncen.
    // Das Theme aktualisiert sie nie (calculateProgress-Aufrufe sind auskommentiert) -> nach Add + Zurück
    // (bfcache) blieb der Fortschritt stale bzw. die Bar versteckt.
    updatePdpShipBar(cart);

    // Drawer-Versandfortschritt (Theme-Element) neu rechnen — sonst bleibt der Balken nach dem Löschen gefüllt
    var sp = document.querySelector('cart-shipping-progress');
    if (sp && sp.updateShippingProgress) { try { sp.updateShippingProgress(); } catch (e) {} }

    // Set-Completion-Hero direkt aus /cart.js aktualisieren (zuverlässig bei AJAX-Add, kein DOM-Timing/Reload nötig)
    var ids = {};
    if (cart.items) for (var q = 0; q < cart.items.length; q++) ids[cart.items[q].product_id] = true;
    updateHero(ids, cart);
    updateSecondHighlight(ids, cart);   // additiv: 2. Highlight statt passiver Reihe
    if (cart.items && cart.items.length) blEnsureH2Attr(cart);   // A/B-Test Holy Poop: Gruppe an den Auftrag
    blSyncOrderAttr(cart);              // verwaiste Upsell-Token aus dem Order-Attribut werfen

    // Versand-Bar
    var bar = document.querySelector('[data-bl-ship]');
    if (!bar) return;
    var free = parseInt(bar.getAttribute('data-free-cents'), 10) || 7000;
    var total = cart.total_price;
    var rem = Math.max(0, free - total);
    var pct = Math.min(100, Math.round((total * 100) / free));
    var reached = total >= free;

    bar.style.display = total > 0 ? 'block' : 'none';
    bar.classList.toggle('bl-ship--done', reached);
    var numOuter = bar.querySelector('.cart-shipping__numOuter');
    var success = bar.querySelector('.cart-shipping__success');
    var num = bar.querySelector('.cart-shipping__num');
    var fill = bar.querySelector('.cart-shippingThreshold__progress');
    if (num) num.textContent = euros(rem);
    if (numOuter) numOuter.style.display = reached ? 'none' : 'block';
    if (success) success.style.display = reached ? 'block' : 'none';
    if (fill) fill.style.width = pct + '%';
  }

  // PDP-Versandbar (Produktseite) aus /cart.js aktualisieren. Schwelle aus dem Attribut free-ship-cost
  // (lokalisiert: DE 70 / AT / CH) lesen, nicht hart 70 annehmen. Num-Span trägt nur die Zahl (Symbol ist Fließtext).
  function updatePdpShipBar(cart) {
    var bars = document.querySelectorAll('.custom-shipping_bar:not([data-bl-ship])');
    for (var i = 0; i < bars.length; i++) {
      var b = bars[i];
      var numEl = b.querySelector('.cart-shipping__num');
      var freeEur = numEl ? parseFloat(numEl.getAttribute('free-ship-cost')) : 70;
      var freeCents = Math.round((freeEur || 70) * 100);
      var total = cart.total_price;
      var rem = Math.max(0, freeCents - total);
      var pct = Math.min(100, Math.round((total * 100) / freeCents));
      var reached = total >= freeCents;
      b.style.display = total > 0 ? 'block' : 'none';
      var fill = b.querySelector('.cart-shippingThreshold__progress');
      var numOuter = b.querySelector('.cart-shipping__numOuter');
      var success = b.querySelector('.cart-shipping__success');
      if (fill) fill.style.width = pct + '%';
      if (numEl) numEl.textContent = (rem / 100).toFixed(2).replace('.', ',');
      if (numOuter) numOuter.style.display = reached ? 'none' : 'block';
      if (success) success.style.display = reached ? 'block' : 'none';
    }
  }

  // ---- Set-Completion-Hero (Build 2) ----
  function readCartProductIds() {
    var map = {}, els = document.querySelectorAll('.cart-item[data-product-id]');
    for (var i = 0; i < els.length; i++) map[els[i].getAttribute('data-product-id')] = true;
    return map;
  }
  var FREE_SHIP = 7000; // €70 Gratisversand-Schwelle (fix)
  // opt (30.10.2026): only = nur dieses Set, exclude = dieses Set nicht, avoid = {Produkt-ID: true} -> Sets, die ein
  // solches Korb-Teil verwenden würden, überspringen (zwei Set-Angebote dürfen sich kein Korb-Teil teilen).
  function bestCandidate(cartIds, cartObj, opt) {
    var sets = window.BL_CART_SETS || [];
    opt = opt || {};
    cartIds = cartIds || readCartProductIds();
    var n = 0, k;
    for (k in cartIds) if (cartIds.hasOwnProperty(k)) n++;
    if (!n) return null;
    var cartTotal = cartObj ? cartObj.total_price : 0;
    var items = (cartObj && cartObj.items) || [];
    // 30.10.2026: Korb-Teile, die nur als angenommenes Upsell im Korb liegen, nicht in ein Set übernehmen (Kennzeichen ginge verloren)
    var free = null, have = cartObj ? cartFlags(cartObj).inCart : {};
    if (cartObj) { free = {}; for (var fi = 0; fi < items.length; fi++) { var fp = items[fi].properties; if (!(fp && fp._bl_upsell)) free[items[fi].product_id] = true; } }
    var best = null;
    for (var i = 0; i < sets.length; i++) {
      var s = sets[i];
      if (cartIds[s.id]) continue; // Set liegt schon im Korb
      if ((opt.only && s.handle !== opt.only) || (opt.exclude && s.handle === opt.exclude)) continue;
      if (s.handle === 'clean-anywhere-set' && cartObj && blH2() === 'B' && loosePod(cartObj)) continue;   // A/B-Test Gruppe B
      var overlap = 0, missing = [], rem = 0, ovComp = null, compIds = {}, ovMin = 0, clash = false;
      for (var j = 0; j < s.comps.length; j++) {
        var c = s.comps[j]; compIds[c.id] = true;
        if (cartIds[c.id] && (!free || free[c.id])) { overlap++; if (!ovComp) ovComp = c; ovMin += c.price || 0; if (opt.avoid && opt.avoid[c.id]) clash = true; }
        // Reinigungs-Set: fehlendes Mittel ohne Nachfrage als 100 ml (erste Variante) -> Ein-Tap (30.10.2026, Lucius)
        else { missing.push(c); if (c.colorful && s.handle !== 'reinigungsset') rem++; }
      }
      if (clash) continue;
      // 30.10.2026: fehlendes Teil steckt schon im Korb (B-Ware-Po-Dusche, Teil eines Sets, angenommenes Upsell) -> kein Angebot
      var dup = false; for (var mi = 0; mi < missing.length; mi++) { if (missing[mi].h && have[missing[mi].h]) dup = true; }
      if (dup) continue;
      // Kandidat: baut auf ≥1 Korb-Produkt auf, ≥1 fehlt, nach Vorbefüllung ≤1 Farbwahl übrig
      if (overlap >= 1 && missing.length >= 1 && rem <= 1) {
        var savePct = s.compare > s.price ? Math.round((1 - s.price / s.compare) * 100) : 0;
        // Strategie: (1) kleiner Schritt zuerst [Ein-Tap + wenige fehlende Teile]
        //            (2) näher an Gratisversand  (3) Ersparnis
        // Aufpreis = Set-Mindestpreis minus Mindestpreise der übernommenen Teile (30.10.2026). Vorher: minus Korbpreis ->
        // bei teureren Varianten (Po-Dusche verpackt, Mittel 300 ml) zu niedrig angezeigt (+1,00 statt +4,00 €), weil
        // s.price der Mindestpreis ist, der Tausch aber die passende teurere Set-Variante nimmt (gleicher Varianten-Aufschlag).
        var overlapVal = ovMin;
        var newTotal = cartTotal + Math.max(0, s.price - overlapVal); // Korbwert nach Set-Vervollständigung
        var gapBonus = newTotal >= FREE_SHIP ? 40 : Math.round(40 * newTotal / FREE_SHIP);
        var score = (rem === 0 ? 100 : 50) - missing.length * 6 + gapBonus + savePct * 0.3;
        if (!best || score > best.score) best = { set: s, missing: missing, ovComp: ovComp, rem: rem, score: score, ovVal: overlapVal };
      }
    }
    return best;
  }
  // ---- Mengen-Upsell (Waschstück & Co.): "Nimm 2 statt 1" ----
  function qtyNum(t) { var m = String(t || '').match(/(\d+)/); return m ? parseInt(m[1], 10) : 1; }
  function qtyCandidate(cartObj) {
    var qps = window.BL_CART_QTY || [];
    if (!cartObj || !cartObj.items || !qps.length) return null;
    for (var i = 0; i < qps.length; i++) {
      var qp = qps[i];
      var tiers = qp.tiers.map(function (t) { return { vid: t.vid, qty: qtyNum(t.title), price: t.price, compare: t.compare, title: t.title }; })
        .sort(function (a, b) { return a.qty - b.qty; });
      for (var j = 0; j < cartObj.items.length; j++) {
        var it = cartObj.items[j];
        if (it.quantity !== 1) continue;                        // nur wenn genau 1 Staffel-Einheit im Korb
        if (it.properties && it.properties._bl_upsell) continue; // 30.10.2026: nicht auf ein gerade angenommenes Upsell nachlegen
        var ti = -1;
        for (var k = 0; k < tiers.length; k++) { if (tiers[k].vid === it.variant_id || tiers[k].vid === it.id) { ti = k; break; } }
        if (ti >= 0 && ti < tiers.length - 1) {
          return { qp: qp, current: tiers[ti], next: tiers[ti + 1], lineVid: (it.variant_id || it.id) };
        }
      }
    }
    return null;
  }
  // 30.10.2026: Karte nur neu schreiben, wenn sich der Inhalt geändert hat -> Bilder blinken nicht bei jedem Korb-Refresh
  function blSetCard(box, html) {
    if (box._blHtml === html && box.firstChild) return;
    box._blHtml = html; box.innerHTML = html;
  }
  function renderQtyHero(box, qc) {
    var cur = qc.current, nx = qc.next;
    var ppNext = Math.round(nx.price / nx.qty);
    var discNext = nx.compare > nx.price ? Math.round((nx.compare - nx.price) * 100 / nx.compare) : 0;
    var addCost = Math.max(0, nx.price - cur.price);            // Aufpreis fürs nächste Stück
    blSetCard(box,
      '<div class="bl-cart-hero__card">' +
        '<div class="bl-cart-hero__head">' +
          '<div class="bl-cart-hero__title">' + (BL_EN ? ('Grab ' + nx.qty + ' now.') : ('Nimm gleich ' + nx.qty + '.')) + '</div>' +
          (discNext > 0 ? '<span class="bl-cart-hero__save">−' + discNext + (BL_EN ? '% each' : '% / Stück') + '</span>' : '') +
        '</div>' +
        '<div class="bl-cart-hero__body">' +
          '<div class="bl-cart-hero__visual"><span class="bl-cart-hero__hv"><img src="' + qc.qp.img + '" alt="" decoding="sync"></span></div>' +
          '<div class="bl-cart-hero__info">' +
            '<div class="bl-cart-hero__text">' + (BL_EN ? ('Make it <b>' + nx.qty + '</b> — just <b>' + euros(ppNext) + ' each</b>.') : ('Mach <b>' + nx.qty + '</b> draus — nur <b>' + euros(ppNext) + ' / Stück</b>.')) + '</div>' +
            '<div class="bl-cart-hero__price"><span class="bl-cart-hero__now">+' + euros(addCost) + '</span><span class="bl-cart-hero__note">' + (BL_EN ? 'for one more' : ('fürs ' + nx.qty + '. Stück')) + '</span></div>' +
          '</div>' +
        '</div>' +
        '<button type="button" class="bl-cart-hero__cta" data-bl-qty-cta data-next="' + nx.vid + '" data-line="' + qc.lineVid + '" data-track="' + (qc.qp.handle || 'qty') + '">' + (BL_EN ? ('Get ' + nx.qty + ' &amp; save') : (nx.qty + ' nehmen &amp; sparen')) + '</button>' +
      '</div>');
    box.hidden = false;
  }

  // ---- Einzel-Zubehör-Upsell (Hauptfall): bestes Zubehör nach Co-Kauf × DB (voller Preis) ----
  // Co-Kauf-Häufigkeiten (echte Orders 60T) + DB je Stück in Cent + Kategorie fürs Matching.
  var ACC_META = {
    // cat = fürs Matching relevante Korb-Kategorie (nach Kollektions-Filtern). Alle diese Zubehöre gehören zur PO-DUSCHE.
    'reinigungsset':           { db: 780,  co_pod: 188, cat: 'po-dusche', label: (BL_EN ? 'Cleaning Set' : 'Reinigungs-Set'), sub: (BL_EN ? 'Cleaner + brush' : 'Reinigungsmittel + Bürste'), txt: (BL_EN ? 'Add the <b>Cleaning Set</b> — keeps your butt shower hygienically clean.' : 'Nimm das <b>Reinigungs-Set</b> dazu — hält deine Po-Dusche hygienisch sauber.') },
    'duschkopf':               { db: 380,  co_pod: 198, cat: 'po-dusche', label: (BL_EN ? 'Turbo Shower Head' : 'Turbo-Duschkopf') },
    'drehverschlussdeckel':    { db: 377,  co_pod: 186, cat: 'po-dusche', label: (BL_EN ? 'Travel Cap' : 'Reisedeckel') },
    'wandhaken-set':           { db: 309,  co_pod: 194, cat: 'po-dusche', label: (BL_EN ? 'Wall Hooks' : 'Wandhaken') },
    'set-po-tucher-3-6-8-stk': { db: 1235, co_pod: 48,  cat: 'po-dusche', label: (BL_EN ? 'Butt Towels' : 'Po-Tücher') }
  };
  var _acand = null;
  // Set-artige Zubehöre, die nachweislich gut konvertieren (Reinigungs-Set: 5,4% Annahme, GA4 28T Stand 05.08.2026).
  // Diese werden VOR der Set-Completion gezeigt; echte Einzelteile (~0,4%) laufen als 'weak'-Fallback ganz hinten.
  var STRONG_ACC = { 'reinigungsset': 1 };
  function accessoryCandidate(cartObj, mode) {   // mode: 'strong' | 'weak' | undefined(=alle)
    var acc = window.BL_CART_ACC || [];
    var setMeta = window.BL_CART_SETMETA || {};
    if (!cartObj || !cartObj.items || !acc.length) return null;
    var inCart = {}, hasPod = false, hasHoc = false;
    for (var i = 0; i < cartObj.items.length; i++) {
      var it = cartObj.items[i], h = it.handle; inCart[h] = true;
      if (h === 'bidetlity-po-dusche') hasPod = true;
      if (h === 'po-dusche-b-ware') { hasPod = true; inCart['bidetlity-po-dusche'] = true; }   // 27.10.2026: B-Ware wie Po-Dusche
      if (h === 'toilettenhocker') hasHoc = true;
      var comps = setMeta[h];                 // Set im Korb -> Kategorie + enthaltene Teile übernehmen (ausschließen)
      if (comps) { for (var c = 0; c < comps.length; c++) { var ch = comps[c]; inCart[ch] = true;
        if (ch === 'bidetlity-po-dusche') hasPod = true; if (ch === 'toilettenhocker') hasHoc = true; } }
    }
    if (!hasPod && !hasHoc) return null;
    var best = null;
    for (var j = 0; j < acc.length; j++) {
      var a = acc[j], m = ACC_META[a.h];
      if (!m || inCart[a.h]) continue;        // kein ACC_META (z.B. Waschstück-Fallback) oder schon im Korb/Set enthalten
      // 30.10.2026 (Lucius): Reinigungs-Set nur bei Hocker OHNE Po-Dusche sperren (ohne Po-Dusche gibt es ohnehin keinen Co-Kauf-Wert).
      // Vorher sperrte jeder Hocker im Korb (auch Holy Poop / All In / Po-Dusche + Hocker) das Reinigungs-Set.
      if (a.h === 'reinigungsset' && hasHoc && !hasPod) continue;
      if (a.h === 'reinigungsset' && looseClean(cartObj)) continue;   // Mittel/Bürste lose im Korb -> Upgrade per Set-Vervollständigung
      if (mode === 'strong' && !STRONG_ACC[a.h]) continue;   // 05.08.2026: nur Set-artige Zubehöre
      if (mode === 'weak' && STRONG_ACC[a.h]) continue;      // 05.08.2026: nur echte Einzelteile
      var co = 0;
      if (hasPod && m.cat.indexOf('po-dusche') > -1 && m.co_pod > co) co = m.co_pod;
      if (co <= 0) continue;
      var score = co * m.db;
      if (!best || score > best.score) best = { acc: a, meta: m, score: score };
    }
    return best;
  }
  // Reinigungsmittel oder Bürste einzeln im Korb (nicht als Reinigungs-Set)
  function looseClean(cartObj) {
    for (var i = 0; i < cartObj.items.length; i++) { var h = cartObj.items[i].handle; if (h === 'activecare-reinigungsmittel' || h === 'reinigungsburste-bidetlity') return true; }
    return false;
  }
  // Angenommene Upsells im Korb (Zeilen mit _bl_upsell). Ab 2 Annahmen kein neues Angebot mehr (30.10.2026).
  function acceptedTokens(cartObj) {
    var seen = {}; seen.n = 0;
    for (var i = 0; i < cartObj.items.length; i++) { var p = cartObj.items[i].properties, t = p && p._bl_upsell; if (t && !seen[t]) { seen[t] = 1; seen.n++; } }
    return seen;
  }
  function acceptedCount(cartObj) { return acceptedTokens(cartObj).n; }
  // Ab 2 Annahmen: die zuletzt gezeigte, NICHT angenommene Karte bleibt unverändert stehen, die angenommene verschwindet,
  // es rückt nichts mehr nach (Lucius 30.10.2026). Gibt true zurück, wenn die Box damit erledigt ist.
  function keepAfterTwo(cartIds, cartObj, box, shown) {
    var acc = acceptedTokens(cartObj);
    if (acc.n < 2) return false;
    var ok = shown && !box.hidden && box.innerHTML && !acc[shown.type + ':' + shown.offer];
    if (ok) {   // gilt das Angebot noch? (Kunde kann z. B. die Po-Dusche gelöscht haben)
      if (shown.type === 'set') ok = !!bestCandidate(cartIds, cartObj, { only: shown.offer });
      else if (shown.type === 'accessory') { var a = accByHandle(shown.offer); ok = !(a && cartIds[a.id]); }
      else ok = false;   // Mengen-Angebot hängt an genau einer Korbzeile -> nicht stehen lassen
    }
    if (!ok) { box.hidden = true; box.innerHTML = ''; return 'cleared'; }
    return 'kept';
  }
  // Produkte mit Farbwahl: im Upsell nie ungefragt die erste Farbe einlegen, sondern das Quick-Add-Sheet öffnen (30.10.2026)
  var COLOR_ACC = { 'toilettenhocker': 1, 'bidetlity-po-dusche': 1, 'wandhaken-set': 1 };
  function dkTxt(a) {
    if (!/turbo/i.test(a.vt || '')) return null;
    return BL_EN ? 'Add the <b>Turbo Tornado</b> — the shower head for more pressure.' : 'Nimm den <b>Turbo Tornado</b> dazu — der Duschkopf für mehr Druck.';
  }
  // Universeller Fallback: Waschstück geht immer (wenn nicht im Korb) — greift erst NACH Set-Completion
  function universalCandidate(cartObj) {
    var acc = window.BL_CART_ACC || [];
    if (!cartObj || !cartObj.items) return null;
    var inCart = {}; for (var i = 0; i < cartObj.items.length; i++) inCart[cartObj.items[i].handle] = true;
    if (inCart['folds-chaos-waschstuck-set'] || inCart['waschstuck-folds-and-chaos']) return null;
    var w = null; for (var j = 0; j < acc.length; j++) { if (acc[j].h === 'folds-chaos-waschstuck-set') w = acc[j]; }
    if (!w) return null;
    return { acc: w, meta: { label: (BL_EN ? 'Cleansing Bar' : 'Waschstück'), badge: (BL_EN ? 'New' : 'Neu'), txt: (BL_EN ? 'Add the <b>Cleansing Bar</b> — one bar for the whole body.' : 'Nimm <b>Waschstück</b> dazu — ein Stück für den ganzen Körper.') }, score: 1 };
  }
  function renderAccessoryHero(box, cand) {
    var a = cand.acc, m = cand.meta;
    var hasDisc = a.compare && a.compare > a.price;
    var disc = hasDisc ? Math.floor((a.compare - a.price) * 100 / a.compare) : 0; // abrunden = konsistent mit Kollektionsseite (Liquid)
    var badge = m.nobadge ? '' : (m.badge ? m.badge : (hasDisc ? (BL_EN ? ('Save ' + disc + '%') : ('Spare ' + disc + '%')) : (BL_EN ? 'most added' : 'meistgekauft dazu')));
    if (a.h === 'duschkopf') m = Object.assign({}, m, dkTxt(a) ? { txt: dkTxt(a) } : { label: (BL_EN ? 'Shower Head' : 'Duschkopf') });
    var txt = m.txt ? m.txt : (hasDisc
      ? (BL_EN ? ('Add <b>' + (m.label || a.name) + '</b> — ' + (m.sub ? m.sub + ', ' : '') + 'already ' + disc + '% cheaper than solo.') : ('Nimm <b>' + (m.label || a.name) + '</b> dazu — ' + (m.sub ? m.sub + ', ' : '') + 'schon ' + disc + ' % günstiger als einzeln.'))
      : (BL_EN ? ('Add <b>' + (m.label || a.name) + '</b> — most people do.') : ('Nimm <b>' + (m.label || a.name) + '</b> dazu — greifen die meisten mit.')));
    blSetCard(box,
      '<div class="bl-cart-hero__card">' +
        '<div class="bl-cart-hero__head">' +
          '<div class="bl-cart-hero__title">' + (BL_EN ? 'Pairs perfectly.' : 'Passt perfekt dazu.') + '</div>' +
          (badge ? '<span class="bl-cart-hero__save">' + badge + '</span>' : '') +
        '</div>' +
        '<div class="bl-cart-hero__body">' +
          '<div class="bl-cart-hero__visual"><span class="bl-cart-hero__hv"><img src="' + a.img + '" alt="" decoding="sync"></span></div>' +
          '<div class="bl-cart-hero__info">' +
            '<div class="bl-cart-hero__text">' + txt + '</div>' +
            '<div class="bl-cart-hero__price"><span class="bl-cart-hero__now">' + euros(a.price) + '</span>' +
              (hasDisc ? '<s class="bl-cart-hero__was">' + euros(a.compare) + '</s>' : '') + '</div>' +
          '</div>' +
        '</div>' +
        ((COLOR_ACC[a.h] && !cand.fixed)
          ? '<button type="button" class="bl-cart-hero__cta" data-qa-open data-handle="' + a.h + '" data-upsell="accessory:' + a.h + '">' + (BL_EN ? 'Choose color' : 'Farbe wählen') + '</button>'
          : '<button type="button" class="bl-cart-hero__cta" data-bl-acc-cta data-vid="' + a.vid + '" data-h="' + a.h + '">' + (m.cta ? m.cta : (BL_EN ? 'Gotta have it' : 'Muss mit')) + '</button>') +
      '</div>');
    box.hidden = false;
  }
  // Hero-Produkt aus der "Passt zu deinem Korb"-Reihe ausblenden (kein Doppel / kein Preis-Konflikt)
  function excludeHeroFromRow() {
    // Hero-Handle + (bei Sets) alle enthaltenen Komponenten ausblenden — sonst steht das
    // beworbene Produkt doppelt im Korb (Hero + „Passt zu deinem Korb"). Bsp. Reinigungs-Set
    // = Reinigungsmittel + Bürste -> beide Einzel-Karten raus.
    var hide = {};
    if (_acand) {
      hide[_acand.acc.h] = true;
      var comps = _acand.meta && _acand.meta.comps;
      if (comps) for (var k = 0; k < comps.length; k++) hide[comps[k]] = true;
    }
    var rec = document.getElementById('cart-recommendations');
    if (!rec) return;
    var items = rec.querySelectorAll('.cart-product-item');
    for (var i = 0; i < items.length; i++) {
      var link = items[i].querySelector('a[href*="/products/"]');
      var ph = link ? link.getAttribute('href').split('/products/')[1].split(/[?#]/)[0] : '';
      items[i].style.display = (ph && hide[ph]) ? 'none' : '';
    }
  }
  function scheduleExclude() { [200, 600, 1200, 2000].forEach(function (ms) { setTimeout(excludeHeroFromRow, ms); }); }

  // ================= Upsell-Impressionen & -Klicks (Teil B) -> GA4 (dataLayer + gtag) =================
  // bl_upsell_view = Angebot im geöffneten Drawer sichtbar (1× je Angebot je Drawer-Öffnung),
  // bl_upsell_add  = Add-/„Set sichern"-CTA erfolgreich. Params: bl_type (set|qty|accessory), bl_offer (handle), bl_value (Cent).
  // ===== A/B-TEST: 50/50 per Cookie (stabil pro Nutzer), Override via ?bl_ab=A|B =====
  var _blVar = null;
  function blSetVarCookie(v) { try { document.cookie = 'bl_ab=' + v + ';path=/;max-age=7776000;SameSite=Lax'; } catch (e) {} }
  function blGetVar() {
    if (_blVar) return _blVar;
    try {
      // A/B abgeschlossen 02.09.2026: Variante B (2 Highlights) gewinnt (+7,1 pp Upsell-Quote, P=95%) -> 100% B ausgerollt.
      // ?bl_ab=A|B bleibt als QA-Override erhalten (z.B. zur Vorschau der alten Reihe). A-Render-Pfade bleiben liegen -> Rollback = nur diese Funktion zurueck.
      var m = location.search.match(/[?&]bl_ab=([abAB])/);
      if (m) { _blVar = m[1].toUpperCase(); blSetVarCookie(_blVar); return _blVar; }
      _blVar = 'B'; blSetVarCookie(_blVar);
      return _blVar;
    } catch (e) { _blVar = 'B'; return _blVar; }
  }
  // ===== A/B-Test 02.11.–26.11.2026 (Lucius): im Korb mit loser Po-Dusche A = Clean Anywhere (bisher), B = Holy Poop statt Clean Anywhere.
  // Gruppe per Cookie bl_h2 (90 Tage), QA-Override ?bl_h2=A|B. Auftrags-Attribute: _bl_h2 (Gruppe, alle Körbe), _bl_h2x=1 (Korb mit loser Po-Dusche).
  var _blH2 = null;
  function blH2() {
    if (_blH2) return _blH2;
    try {
      var m = location.search.match(/[?&]bl_h2=([abAB])/), c = document.cookie.match(/(?:^|;\s*)bl_h2=([AB])/);
      _blH2 = m ? m[1].toUpperCase() : (c ? c[1] : (Math.random() < 0.5 ? 'A' : 'B'));
      document.cookie = 'bl_h2=' + _blH2 + ';path=/;max-age=7776000;SameSite=Lax';
    } catch (e) { _blH2 = 'A'; }
    return _blH2;
  }
  window.blH2 = blH2;
  // Test-Korb: lose Po-Dusche (keine B-Ware), kein Hocker (sonst ist Holy Poop nicht möglich), Holy Poop lieferbar
  function loosePod(cartObj) {
    var pod = false;
    for (var i = 0; i < cartObj.items.length; i++) if (cartObj.items[i].handle === 'bidetlity-po-dusche') pod = true;
    if (!pod || cartFlags(cartObj).hasHoc) return false;
    var sets = window.BL_CART_SETS || [];
    for (var j = 0; j < sets.length; j++) if (sets[j].handle === 'the-holy-poop') return true;
    return false;
  }
  var _blH2Attr = '';
  function blEnsureH2Attr(cartObj) {
    var want = blH2() + (loosePod(cartObj) ? 'x' : '');
    var cur = cartObj.attributes || {};
    if (want === _blH2Attr || (cur._bl_h2 === blH2() && (want.indexOf('x') < 0 || cur._bl_h2x === '1'))) { _blH2Attr = want; return; }
    _blH2Attr = want;
    var a = { '_bl_h2': blH2() }; if (want.indexOf('x') > -1) a._bl_h2x = '1';
    try { fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ attributes: a }) }).catch(function () {}); } catch (e) {}
  }
  function blUpsellTrack(evt, type, offer, valueCents) {
    if (!type) return;
    try {
      var p = { event: evt, bl_type: type, bl_offer: offer || '', bl_variant: blGetVar(), bl_h2: blH2() };
      if (valueCents != null && !isNaN(valueCents)) p.bl_value = Math.round(valueCents);
      (window.dataLayer = window.dataLayer || []).push(p);
      if (typeof window.gtag === 'function') { var g = { bl_type: type, bl_offer: offer || '', bl_variant: blGetVar(), bl_h2: blH2() }; if (p.bl_value != null) g.bl_value = p.bl_value; window.gtag('event', evt, g); }
    } catch (e) {}
  }
  window.blUpsellTrack = blUpsellTrack; // damit das Quick-Add-Sheet (bl-quickadd.js, Set-Completion mit Restwahl) den Add mitzählen kann
  // Variante als Order-Attribut sichern (einmal je Seite) -> jede Bestellung trägt A/B fürs Dashboard
  var _blAbSet = false;
  function blEnsureAbAttr() {
    if (_blAbSet) return; _blAbSet = true;
    try { fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ attributes: { '_bl_ab': blGetVar() } }) }).catch(function () {}); } catch (e) {}
  }
  // Order-Level-Attribut: schreibt die Upsell-Annahme als Cart-Attribut `_bl_upsell` (kommasepariert, dedupliziert).
  // GRUND: Die line-item-Property `_bl_upsell` STIRBT bei nativen Bundles (Reinigungs-Set + alle Sets), weil sich das
  // Bundle auf der Bestellung in Komponenten zerlegt. Ein Cart-Attribut hängt an der BESTELLUNG (order.customAttributes)
  // und überlebt die Zerlegung -> damit ist die Annahme->Kauf-Attribution auch für Sets möglich. Gibt ein Promise zurück,
  // damit es VOR einem Reload sauber durchläuft (kein fire-and-forget bei den reloadenden Pfaden).
  function blSetOrderAttr(type, offer) {
    if (!type || !offer) return Promise.resolve();
    blAttrHold();   // Sync anhalten, sonst kann er dieses read-modify-write ueberschreiben
    var token = type + ':' + offer;
    return fetch('/cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var cur = (cart.attributes && cart.attributes._bl_upsell) || '';
        var parts = cur ? cur.split(',') : [];
        if (parts.indexOf(token) === -1) parts.push(token);
        return fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ attributes: { '_bl_upsell': parts.join(',') } }) });
      }).catch(function () {});
  }
  window.blSetOrderAttr = blSetOrderAttr;
  // --- Phantom-Schutz fuer `_bl_upsell` (06.09.2026) --------------------------------------
  // blSetOrderAttr haengt nur an. Loeschte der Kunde die angenommene Zeile wieder aus dem Korb,
  // blieb der Token im Attribut stehen -> Bestellung #39659 trug `accessory:toilettenhocker`
  // ohne Hocker. Gegenmittel: bei jedem Cart-Update jeden Token verwerfen, fuer den KEINE Zeile
  // mehr die passende line-item-Property `_bl_upsell` traegt.
  // Sicher, weil ein natives Bundle im KORB noch EINE Zeile mit erhaltener Property ist
  // (am 06.09. gegen den Live-Shop geprueft) — die Zerlegung passiert erst auf der Bestellung,
  // das Attribut ueberlebt sie also unveraendert.
  // Es wird nur ENTFERNT, nie ergaenzt: die Reihe „Passt zu deinem Korb" (setzt nur die
  // Property, kein Attribut) bleibt wie bisher aussen vor -> A/B-Zaehlung bleibt vergleichbar.
  var _blAttrBusy = 0;  // >0 = Annahme laeuft gerade -> Sync pausieren (sonst ueberholt er blSetOrderAttr)
  function blAttrHold(ms) {
    _blAttrBusy++;
    setTimeout(function () { if (_blAttrBusy > 0) _blAttrBusy--; }, ms || 6000);
  }
  window.blAttrHold = blAttrHold;
  function blSyncOrderAttr(cart) {
    if (_blAttrBusy > 0) return;
    try {
      var cur = (cart.attributes && cart.attributes._bl_upsell) || '';
      if (!cur) return;
      var live = {}, items = cart.items || [], i, t;
      for (i = 0; i < items.length; i++) {
        t = items[i].properties && items[i].properties._bl_upsell;
        if (t) live[String(t)] = true;
      }
      var parts = cur.split(','), keep = [];
      for (i = 0; i < parts.length; i++) {
        if (live[parts[i]] && keep.indexOf(parts[i]) === -1) keep.push(parts[i]);
      }
      var next = keep.join(',');
      if (next === cur) return;   // nichts verwaist -> kein Schreibvorgang, keine Schleife
      fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: { '_bl_upsell': next } }) }).catch(function () {});
    } catch (e) {}
  }
  function blDrawerOpen() { var d = document.getElementById('site-cart'); return !!(d && d.classList.contains('active')); }
  var _blViewed = {};   // Dedupe je Drawer-Öffnung: "type:offer" -> true
  var _blHero = null;   // aktuell gerendertes Hero-Angebot {type, offer, value}
  function blFireView(type, offer, valueCents) {
    if (!type || !offer || !blDrawerOpen()) return;
    var k = type + ':' + offer;
    if (_blViewed[k]) return;
    _blViewed[k] = true;
    blUpsellTrack('bl_upsell_view', type, offer, valueCents);
  }
  function blFireRowViews() { // Zubehör-Reihe „Passt zu deinem Korb" — sichtbare Karten
    if (!blDrawerOpen()) return;
    var rec = document.getElementById('cart-recommendations');
    if (!rec) return;
    var items = rec.querySelectorAll('.cart-product-item');
    for (var i = 0; i < items.length; i++) {
      if (items[i].offsetParent === null) continue; // display:none -> nicht sichtbar
      var link = items[i].querySelector('a[href*="/products/"]');
      if (!link) continue;
      var parts = link.getAttribute('href').split('/products/')[1];
      if (parts) blFireView('accessory', parts.split(/[?#]/)[0], null);
    }
  }
  function blOnDrawerOpen() { _blViewed = {}; blUpsellTrack('bl_cart_open', 'ab', blGetVar()); if (_blHero) blFireView(_blHero.type, _blHero.offer, _blHero.value); if (_blHero2) blFireView(_blHero2.type, _blHero2.offer, _blHero2.value); blFireRowViews(); }

  // ===== Rotation der Bidet-Zubehoer-Angebote (28.09.2026, Lucius) =====
  // Po-Tuecher / mobile Po-Dusche / Toilettenhocker rotieren, damit messbar wird, was bei
  // Deluxe- und New-Standard-Koerben am besten ankommt. EIN Los pro Besucher (Cookie, 30 Tage),
  // sonst sieht derselbe Kunde bei jedem Oeffnen etwas anderes und die Messung ist wertlos.
  // QA: ?bl_rot=0|1|2 erzwingt ein Los.  Wasserfilter + Waschstueck sind hier bewusst RAUS
  // (Filter: Restbestand strecken; Waschstueck: 420 Einblendungen -> 3 Annahmen, 14 T Stand 28.09.).
  var BIDET_ROT = ['set-po-tucher-3-6-8-stk', 'bidetlity-po-dusche', 'toilettenhocker'];
  var _blRot = null;
  function blRotBucket() {
    if (_blRot != null) return _blRot;
    try {
      var q = location.search.match(/[?&]bl_rot=([0-2])/);
      if (q) { _blRot = +q[1]; document.cookie = 'bl_rot=' + _blRot + ';path=/;max-age=2592000;SameSite=Lax'; return _blRot; }
      var m = document.cookie.match(/(?:^|;\s*)bl_rot=([0-2])/);
      if (m) { _blRot = +m[1]; return _blRot; }
      _blRot = Math.floor(Math.random() * BIDET_ROT.length);
      document.cookie = 'bl_rot=' + _blRot + ';path=/;max-age=2592000;SameSite=Lax';
    } catch (e) { _blRot = 0; }
    return _blRot;
  }
  function blRotOrder() {
    var b = blRotBucket(), out = [];
    for (var i = 0; i < BIDET_ROT.length; i++) out.push(BIDET_ROT[(b + i) % BIDET_ROT.length]);
    return out;
  }
  // Bidet-Hero: gezielte Zuordnung, da Bidet-Koerbe sonst keinen Accessory-Hero bekommen
  // (accessoryCandidate ist Po-Dusche/Hocker-zentriert). Deluxe -> Wasserfilter (Kalkschutz),
  // New Standard -> Waschstueck (kein Filter, bewusste Entscheidung).
  // 27.10.2026 (Lucius): Rotation beendet. Auswertung 29.09.-27.10. (124 Bidet-Bestellungen): Po-Tuecher 5 Annahmen, Hocker 2, Po-Dusche 0;
  // Wasserfilter bei Deluxe vorher 10 von 35. Feste Reihenfolge: Deluxe = Filter, Po-Tuecher, Hocker; New Standard = Po-Tuecher, Hocker.
  var BIDET_FEST = { DLX: ['wasserfilter', 'set-po-tucher-3-6-8-stk', 'toilettenhocker'], NS: ['set-po-tucher-3-6-8-stk', 'toilettenhocker'] };
  // A/B-Test ab 30.10.2026 (Lucius), gleiche Gruppe wie der Holy-Poop-Test (bl_h2, andere Körbe): New Standard B = Hocker vor Po-Tüchern
  function bidetFest(key) { return (key === 'NS' && blH2() === 'B') ? ['toilettenhocker', 'set-po-tucher-3-6-8-stk'] : BIDET_FEST[key]; }
  var BIDET_HERO = { 'bidetlity-deluxe-dusch-wc-aufsatz': 'DLX', 'bidetlity-deluxe-sitz-komponente': 'DLX',
    'bidetlity-new-standard-bidet-aufsatz-ohne-strom': 'NS', 'bidetlity-new-standard-100cm': 'NS',
    'bidetlity-new-standard-200cm': 'NS', 'bidetlity-new-standard-300cm': 'NS',
    'bidetlity-new-standard-400cm': 'NS' };   // 'ROT' = rotierende Liste, siehe blRotOrder()
  function heroMeta(wanted) {
    if (wanted === 'wasserfilter') return { label: (BL_EN ? 'Water Filter' : 'Wasserfilter'), badge: (BL_EN ? 'Protects the tech' : 'Schützt die Technik'), txt: (BL_EN ? 'Add the <b>Water Filter</b> — protects nozzle &amp; internals from limescale.' : 'Nimm den <b>Wasserfilter</b> dazu — schützt Düse &amp; Technik vor Kalk.') };
    if (wanted === 'folds-chaos-waschstuck-set') return { label: (BL_EN ? 'Cleansing Bar' : 'Waschstück'), nobadge: true, txt: (BL_EN ? 'Add the <b>Cleansing Bar</b> — one bar for the whole body.' : 'Nimm das <b>Waschstück</b> dazu — ein Stück für den ganzen Körper.') };
    if (wanted === 'set-po-tucher-3-6-8-stk') return { label: (BL_EN ? 'Butt Towels' : 'Po-Tücher'), nobadge: true, txt: (BL_EN ? 'Add the reusable <b>Butt Towels</b> — soft, washable, done.' : 'Nimm die wiederverwendbaren <b>Po-Tücher</b> dazu — weich, waschbar, fertig.') };
    if (wanted === 'bidetlity-po-dusche') return { label: (BL_EN ? 'Portable Butt Shower' : 'Mobile Po-Dusche'), badge: (BL_EN ? 'Bestseller' : 'Bestseller'), txt: (BL_EN ? 'Add the <b>portable Butt Shower</b> — water wherever you are.' : 'Nimm die <b>mobile Po-Dusche</b> dazu — Wasser auch unterwegs.') };
    if (wanted === 'toilettenhocker') return { label: (BL_EN ? 'Toilet Stool' : 'Toilettenhocker'), nobadge: true, txt: (BL_EN ? 'Add the <b>Toilet Stool</b> — the natural squat position.' : 'Nimm den <b>Toilettenhocker</b> dazu — die richtige Hockhaltung.') };
    return { label: '', nobadge: true, txt: '' };
  }
  function bidetCandidate(cartObj) {
    var acc = window.BL_CART_ACC || [];
    if (!cartObj || !cartObj.items || !acc.length) return null;
    var inCart = {}; for (var i = 0; i < cartObj.items.length; i++) inCart[cartObj.items[i].handle] = true;
    for (var i = 0; i < cartObj.items.length; i++) {
      var list = BIDET_HERO[cartObj.items[i].handle];
      if (!list) continue;
      if (list === 'ROT') list = blRotOrder();
      else if (BIDET_FEST[list]) list = bidetFest(list);
      else if (typeof list === 'string') list = [list];
      for (var k = 0; k < list.length; k++) {
        var wanted = list[k];
        if (inCart[wanted]) continue;
        if (wanted === 'reinigungsset' && inCart['toilettenhocker']) continue;
        var a = null; for (var j = 0; j < acc.length; j++) { if (acc[j].h === wanted) { a = acc[j]; break; } }
        if (!a) continue;
        return { acc: a, meta: heroMeta(wanted), score: 99 };
      }
    }
    return null;
  }
  // ===== ZWEITES HIGHLIGHT (additiv) — ersetzt die passive "Passt zu deinem Korb"-Reihe =====
  // Highlight 1 (updateHero) bleibt komplett unberührt. Hier NUR ein ergänzendes 2. Angebot,
  // passend zum Korb + zu Highlight 1 (kein Doppel). Reinigungs-Set nur mit Po-Dusche.
  var _blHero2 = null, _blHero2Set = null;
  // ===== R.I.P. (All Black Bundle) im Korb: Reinigungs-Set + schwarzer Wandhaken (10.10.2026, Lucius) =====
  // Das Bundle enthält Po-Dusche + Hocker schon -> nie „Po-Dusche dazu". Beide Karten unabhängig von der A/B-Variante.
  function ripOffers(cartObj) {
    var cfg = window.BL_CART_RIP; if (!cfg || !cartObj || !cartObj.items) return null;
    var inCart = {}, has = false;
    for (var i = 0; i < cartObj.items.length; i++) { inCart[cartObj.items[i].handle] = true; if (cartObj.items[i].handle === cfg.handle) has = true; }
    if (!has) return null;
    var out = [], rs = accByHandle('reinigungsset');
    if (rs && !inCart['reinigungsset'] && !looseClean(cartObj)) out.push({ kind: 'accessory', acc: rs, meta: h2Meta('reinigungsset') });
    if (cfg.hook && !inCart['wandhaken-set']) out.push({ kind: 'accessory', fixed: true, acc: cfg.hook, meta: { label: (BL_EN ? 'Wall Hook' : 'Wandhaken'), nobadge: true, cta: (BL_EN ? 'Add it too' : 'Dazu nehmen'),
      txt: (BL_EN ? '<b>Wall hook</b> to hang it up. Black like the rest.' : '<b>Wandhaken</b> zum Aufhängen. Schwarz wie der Rest.') } });
    return out;
  }
  function accByHandle(h) { var acc = window.BL_CART_ACC || []; for (var j = 0; j < acc.length; j++) if (acc[j].h === h) return acc[j]; return null; }
  function h2Meta(h) {
    if (h === 'reinigungsset') return { label: (BL_EN ? 'Cleaning Set' : 'Reinigungs-Set'), sub: (BL_EN ? 'cleaner + brush' : 'Reinigungsmittel + Bürste'), badge: (BL_EN ? 'most added' : 'meistgekauft dazu'), cta: (BL_EN ? 'Add it too' : 'Dazu nehmen'), txt: (BL_EN ? 'Add the <b>Cleaning Set</b> — keeps your butt shower hygienically clean.' : 'Nimm das <b>Reinigungs-Set</b> dazu — hält deine Po-Dusche hygienisch sauber.') };
    if (h === 'duschkopf') { var dk = accByHandle('duschkopf');
      return { label: (dk && dkTxt(dk)) ? (BL_EN ? 'Shower Head' : 'Turbo-Duschkopf') : (BL_EN ? 'Shower Head' : 'Duschkopf'), badge: (BL_EN ? 'top pairing' : 'Top-Kombi'), cta: (BL_EN ? 'Add it too' : 'Dazu nehmen'), txt: (dk && dkTxt(dk)) || (BL_EN ? 'Add a second <b>shower head</b> — the #1 add-on for the Po-Dusche.' : 'Nimm einen zweiten <b>Duschkopf</b> dazu — das Zubehör Nr. 1 zur Po-Dusche.') }; }
    var m = heroMeta(h); m.cta = (BL_EN ? 'Add it too' : 'Dazu nehmen'); return m;
  }
  function cartFlags(cartObj) {
    var setMeta = window.BL_CART_SETMETA || {};
    var f = { inCart: {}, hasPod: false, hasHoc: false, hasDeluxe: false, hasNS: false, hasPodAcc: false };
    var POD_ACC = { duschkopf: 1, drehverschlussdeckel: 1, 'wandhaken-set': 1, reinigungsset: 1, 'set-po-tucher-3-6-8-stk': 1 };
    function mark(h) {
      if (!h) return; f.inCart[h] = true;
      if (h === 'bidetlity-po-dusche') f.hasPod = true;
      else if (h === 'po-dusche-b-ware') { f.hasPod = true; f.inCart['bidetlity-po-dusche'] = true; }   // 27.10.2026: B-Ware wie Po-Dusche
      else if (h === 'toilettenhocker') f.hasHoc = true;
      else if (h.indexOf('bidetlity-deluxe') === 0) f.hasDeluxe = true;
      else if (h.indexOf('bidetlity-new-standard') === 0) f.hasNS = true;
      if (POD_ACC[h]) f.hasPodAcc = true;
    }
    for (var i = 0; i < cartObj.items.length; i++) { mark(cartObj.items[i].handle); var c = setMeta[cartObj.items[i].handle]; if (c) for (var k = 0; k < c.length; k++) mark(c[k]); }
    if (f.inCart['waschstuck-folds-and-chaos']) f.inCart['folds-chaos-waschstuck-set'] = true;
    return f;
  }
  function pickAcc(f, order, exclude, exclIds) {
    for (var k = 0; k < order.length; k++) {
      var h = order[k]; if (h === exclude || f.inCart[h]) continue;
      var a = accByHandle(h); if (!a) continue;
      if (exclIds && exclIds[a.id]) continue;
      return { kind: 'accessory', acc: a, meta: h2Meta(h) };
    }
    return null;
  }
  // 2. Angebot bestimmen (ergänzend zu Highlight 1; Set-Scorer entscheidet die Set-Abrundung selbst)
  function secondOffer(cartIds, cartObj, hero1) {
    var f = cartFlags(cartObj); var exclude = hero1 ? hero1.offer : '';
    // Ist Highlight 1 eine Set-Vervollständigung: deren Korb-Teile nicht doppelt verplanen, deren fehlende Teile nicht einzeln anbieten
    var avoid = {}, exclIds = {}, h1c = (hero1 && hero1.type === 'set') ? _cand : null;
    if (h1c && h1c.set) { h1c.set.comps.forEach(function (c) { if (cartIds[c.id]) avoid[c.id] = true; }); h1c.missing.forEach(function (c) { exclIds[c.id] = true; }); }
    if (f.hasPod) {
      // 30.10.2026: Reinigungs-Set als 2. Angebot, wenn Highlight 1 etwas anderes zeigt (z. B. Deluxe + Po-Dusche -> Filter oben)
      if (exclude !== 'reinigungsset' && !f.inCart['reinigungsset'] && !looseClean(cartObj)) { var rsA = accByHandle('reinigungsset'); if (rsA) return { kind: 'accessory', acc: rsA, meta: h2Meta('reinigungsset') }; }
      // 30.10.2026: Set abrunden auch, wenn Highlight 1 schon ein Set ist (nächstbestes Set ohne gemeinsame Korb-Teile)
      // -> Duschkopf -> Hocker -> Po-Tücher -> Waschstück (z. B. All In: alles andere steckt schon im Set)
      var setc = bestCandidate(cartIds, cartObj, { exclude: exclude, avoid: avoid });
      if (setc && !f.inCart[setc.set.handle]) return { kind: 'set', cand: setc };
      return pickAcc(f, ['duschkopf', 'toilettenhocker', 'set-po-tucher-3-6-8-stk', 'folds-chaos-waschstuck-set'], exclude, exclIds);
    }
    // 30.10.2026 (Lucius): Hocker ohne Po-Dusche -> Waschstück (Po-Tücher gehen nur mit Po-Dusche, 1 von 421 angenommen)
    if (f.hasHoc) return pickAcc(f, ['folds-chaos-waschstuck-set'], exclude, exclIds);
    // 28.09.2026: Deluxe/NS bekommen das naechste Angebot aus der Rotation (Waschstueck raus).
    if (f.hasDeluxe) return pickAcc(f, BIDET_FEST.DLX, exclude);   // 27.10.2026: feste Reihenfolge statt Rotation
    if (f.hasNS) return pickAcc(f, bidetFest('NS'), exclude);
    return pickAcc(f, ['toilettenhocker', 'set-po-tucher-3-6-8-stk', 'bidetlity-po-dusche'], exclude);
  }
  // Fallback, wenn Highlight 1 leer ist (seltene reine-Zubehör-Körbe) -> nie leer
  function fallbackOffer(cartObj) {
    var f = cartFlags(cartObj);
    if (f.hasPodAcc) return pickAcc(f, ['reinigungsset', 'toilettenhocker', 'set-po-tucher-3-6-8-stk'], '');  // besitzt Po-Dusche (Waschstueck raus 28.09.2026)
    var pod = accByHandle('bidetlity-po-dusche');
    if (pod && !f.inCart['bidetlity-po-dusche']) return { kind: 'accessory', acc: pod, meta: { label: 'Po-Dusche', badge: (BL_EN ? 'Bestseller' : 'Bestseller'), cta: (BL_EN ? 'Add it too' : 'Dazu nehmen'), txt: (BL_EN ? 'Add the <b>Portable Butt Shower</b> — water wherever you are.' : 'Nimm die <b>Po-Dusche</b> dazu — das mobile Bidet.') } };
    return pickAcc(f, ['reinigungsset', 'toilettenhocker', 'set-po-tucher-3-6-8-stk'], '');
  }
  // Set-Karte für Highlight 2 (eigene Funktion -> Highlight 1 bleibt unberührt)
  // 30.10.2026: Preisanker – Summe der fehlenden Teile einzeln (Mindestpreise), wenn das Set günstiger ist
  function setNote(cand, delta) {
    var miss = 0; cand.missing.forEach(function (c) { miss += c.price || 0; });
    if (miss > delta) return BL_EN ? ('vs. ' + euros(miss) + ' solo') : ('statt ' + euros(miss) + ' einzeln');
    return BL_EN ? 'Extra for the set' : 'Aufpreis fürs Set';
  }
  function setCard2HTML(cand, cartObj) {
    var s = cand.set;
    var names = cand.missing.map(function (c) { return c.name; }).join(' & ');
    var saveEuro = s.compare > s.price ? euros(s.compare - s.price) : null;
    var delta = Math.max(0, s.price - (cand.ovVal || 0));
    var leftImg = (cand.ovComp && cand.ovComp.img) ? cand.ovComp.img : s.img;
    var rightImg = (cand.missing[0] && cand.missing[0].img) ? cand.missing[0].img : s.img;
    var overlapKeys = [];
    if (cartObj && cartObj.items && s.comps) { var ci = {}; s.comps.forEach(function (c) { ci[c.id] = true; }); cartObj.items.forEach(function (it) { if (ci[it.product_id] && !(it.properties && it.properties._bl_upsell)) { overlapKeys.push(it.key); ci[it.product_id] = false; } }); }
    var cta = (cand.rem === 1)
      ? '<button type="button" class="bl-cart-hero__cta" data-qa-open data-no-nav data-handle="' + s.handle + '" data-upsell="set:' + s.handle + '" data-delta="' + delta + '"' + (overlapKeys.length ? ' data-remove-keys="' + overlapKeys.join(',') + '"' : '') + '>' + (BL_EN ? 'Complete the set' : 'Set komplett machen') + '</button>'
      : '<button type="button" class="bl-cart-hero__cta" data-bl-h2set>' + (BL_EN ? 'Complete the set' : 'Set komplett machen') + '</button>';
    return '<div class="bl-cart-hero__card">' +
      '<div class="bl-cart-hero__head"><div class="bl-cart-hero__title">' + (BL_EN ? 'Round out your set.' : 'Mach’s komplett.') + '</div>' +
        (saveEuro ? '<span class="bl-cart-hero__save">' + (BL_EN ? 'Save ' : 'Spare ') + saveEuro + '</span>' : '') + '</div>' +
      '<div class="bl-cart-hero__body"><div class="bl-cart-hero__visual">' +
        (leftImg ? '<span class="bl-cart-hero__hv"><img src="' + leftImg + '" alt="" decoding="sync"></span><span class="bl-cart-hero__plus">+</span>' : '') +
        '<span class="bl-cart-hero__hv"><img src="' + rightImg + '" alt="" decoding="sync"></span></div>' +
      '<div class="bl-cart-hero__info"><div class="bl-cart-hero__text">' + (BL_EN ? ('Add <b>' + names + '</b> — as <b>' + s.title + '</b>.') : ('Nimm <b>' + names + '</b> dazu — als <b>' + s.title + '</b>.')) + '</div>' +
        '<div class="bl-cart-hero__price"><span class="bl-cart-hero__now">+' + euros(delta) + '</span><span class="bl-cart-hero__note">' + setNote(cand, delta) + '</span></div></div></div>' + cta + '</div>';
  }
  function renderSecond(box2, offer, cartObj) {
    if (offer.kind === 'set') {
      _blHero2Set = offer.cand;
      blSetCard(box2, setCard2HTML(offer.cand, cartObj)); box2.hidden = false;
      _blHero2 = { type: 'set', offer: offer.cand.set.handle, value: Math.max(0, offer.cand.set.price - (offer.cand.ovVal || 0)) };
    } else {
      _blHero2Set = null;
      renderAccessoryHero(box2, offer);   // nutzt meta.cta ("Dazu nehmen")
      _blHero2 = { type: 'accessory', offer: offer.acc.h, value: offer.acc.price };
    }
    blFireView(_blHero2.type, _blHero2.offer, _blHero2.value);
  }
  function updateSecondHighlight(cartIds, cartObj) {
    var box2 = document.querySelector('[data-bl-hero2]'); if (!box2) return;
    var box1 = document.querySelector('[data-bl-hero]');
    var prev2 = _blHero2, prev2Set = _blHero2Set;
    _blHero2 = null; _blHero2Set = null;
    if (!cartObj || !cartObj.items || !cartObj.items.length) { box2.hidden = true; box2.innerHTML = ''; return; }
    var k2 = keepAfterTwo(cartIds, cartObj, box2, prev2); if (k2) { if (k2 === 'kept') { _blHero2 = prev2; _blHero2Set = prev2Set; } return; }   // 30.10.2026: ab 2 Annahmen
    blEnsureAbAttr();                                   // A/B: Variante an die Bestellung hängen
    var rip2 = ripOffers(cartObj);                      // R.I.P.: zweite Karte fest, unabhängig von der Variante
    if (rip2) {
      var h1 = (box1 && !box1.hidden && _blHero) ? _blHero.offer : '', o2 = null;
      for (var r = 0; r < rip2.length; r++) { if (rip2[r].acc.h !== h1) { o2 = rip2[r]; break; } }
      if (!o2) { box2.hidden = true; box2.innerHTML = ''; return; }
      renderSecond(box2, o2, cartObj); box2.hidden = false; return;
    }
    if (blGetVar() !== 'B') { box2.hidden = true; box2.innerHTML = ''; return; }  // Variante A -> altes Verhalten (Reihe bleibt)
    var offer;
    if (box1 && !box1.hidden && _blHero) offer = secondOffer(cartIds, cartObj, _blHero);  // H1 aktiv -> ergänzen
    else offer = fallbackOffer(cartObj);                                                   // H1 leer -> nie leer
    if (!offer) { box2.hidden = true; box2.innerHTML = ''; return; }
    renderSecond(box2, offer, cartObj);
  }

  var _cand = null;
  function updateHero(cartIds, cartObj) {
    var box = document.querySelector('[data-bl-hero]');
    if (!box) return;
    if (!cartObj) return; // Hero nur aus /cart.js rendern (verlässlich) -> kein Set->Zubehör-Flash beim Öffnen
    // Leerer Warenkorb -> KEINE Empfehlung (auch kein universeller Fallback)
    if (!cartObj.items || !cartObj.items.length || cartObj.item_count === 0) { _blHero = null; box.hidden = true; box.innerHTML = ''; return; }
    // 30.10.2026 (Lucius): Nach einer Annahme rückt das nächstbeste Angebot nach; ab 2 Annahmen keine Karten mehr (nicht pushy).
    // Vorher: schon nach der ersten Annahme keine Hero-Karte mehr.
    var k1 = keepAfterTwo(cartIds, cartObj, box, _blHero); if (k1) { if (k1 === 'cleared') { _blHero = null; _cand = null; _acand = null; } return; }
    // 0a. R.I.P. im Korb -> festes Paar (Reinigungs-Set, schwarzer Wandhaken)
    var rip = ripOffers(cartObj);
    if (rip) {
      if (!rip.length) { _blHero = null; box.hidden = true; box.innerHTML = ''; return; }
      _cand = null; _acand = rip[0]; renderAccessoryHero(box, rip[0]); box.hidden = false; excludeHeroFromRow(); scheduleExclude();
      _blHero = { type: 'accessory', offer: rip[0].acc.h, value: rip[0].acc.price }; blFireView(_blHero.type, _blHero.offer, _blHero.value); return;
    }
    // 0. Bidet im Korb -> gezielter Hero (Deluxe -> Wasserfilter, New Standard -> Waschstück)
    // 30.10.2026 (Lucius): New Standard + Po-Dusche -> Reinigungs-Set oben statt Bidet-Liste; Deluxe behält den Wasserfilter oben
    var fb = cartFlags(cartObj);
    var bc = (fb.hasNS && fb.hasPod && !fb.hasDeluxe) ? null : bidetCandidate(cartObj);
    if (bc) { _cand = null; _acand = bc; renderAccessoryHero(box, bc); excludeHeroFromRow(); scheduleExclude(); _blHero = { type: 'accessory', offer: bc.acc.h, value: bc.acc.price }; blFireView(_blHero.type, _blHero.offer, _blHero.value); return; }
    // 1. Po-Dusche im Korb -> Reinigungs-Set IMMER zuerst (bestes Angebot, ~6 % Annahme). 30.10.2026 (Lucius):
    //    vor dem Mengen-Upsell, der es vorher bei Po-Dusche + Wandhaken/Waschstück verdrängt hat.
    var acStrong = accessoryCandidate(cartObj, 'strong');
    if (acStrong) { _cand = null; _acand = acStrong; renderAccessoryHero(box, acStrong); excludeHeroFromRow(); scheduleExclude(); _blHero = { type: 'accessory', offer: acStrong.acc.h, value: acStrong.acc.price }; blFireView(_blHero.type, _blHero.offer, _blHero.value); return; }
    _acand = null;
    var fl = cartFlags(cartObj);
    // 1b. Po-Dusche + Reinigungsmittel/Bürste lose -> Upgrade zum Reinigungs-Set (Tausch, kein doppeltes Mittel)
    var cand = (fl.hasPod && !fl.inCart['reinigungsset'] && looseClean(cartObj)) ? bestCandidate(cartIds, cartObj, { only: 'reinigungsset' }) : null;
    if (!cand) {
      // 2. Mengen-Upsell (Waschstück/Wandhaken 1->2) nur ohne Po-Dusche (bringt ~1-4 € Rohertrag, Reinigungs-Set ~7 €)
      var qc = fl.hasPod ? null : qtyCandidate(cartObj);
      if (qc) { _cand = null; _acand = null; renderQtyHero(box, qc); excludeHeroFromRow(); _blHero = { type: 'qty', offer: (qc.qp.handle || 'qty'), value: Math.max(0, qc.next.price - qc.current.price) }; blFireView(_blHero.type, _blHero.offer, _blHero.value); return; }
      // 3. Set-Completion (lose Set-Komponenten im Korb -> Set vervollständigen; Set-Angebote ~5% Annahme)
      cand = bestCandidate(cartIds, cartObj);
    }
    _cand = cand;
    if (!cand) {
      // 4. Fallback: Einzel-Zubehör. Bewusst GANZ HINTEN — Einzelteile konvertieren nur ~0,4% (GA4 28T, 05.08.2026),
      //    Set-artige Angebote ~13-17× besser. Vorher standen Einzelteile vor der Set-Completion.
      var acWeak = accessoryCandidate(cartObj, 'weak');
      if (acWeak) { _acand = acWeak; renderAccessoryHero(box, acWeak); excludeHeroFromRow(); scheduleExclude(); _blHero = { type: 'accessory', offer: acWeak.acc.h, value: acWeak.acc.price }; blFireView(_blHero.type, _blHero.offer, _blHero.value); return; }
      // Kein relevanter Treffer -> KEIN Hero (kein universeller Waschstück-Fallback; drückt sonst die Conversion).
      _blHero = null; box.hidden = true; box.innerHTML = ''; return;
    }
    var s = cand.set;
    var names = cand.missing.map(function (c) { return c.name; }).join(' & ');
    var saveEuro = s.compare > s.price ? euros(s.compare - s.price) : null;
    var delta = Math.max(0, s.price - (cand.ovVal || 0));           // Aufpreis: Setpreis minus schon im Korb liegende Set-Teile
    var leftImg = (cand.ovComp && cand.ovComp.img) ? cand.ovComp.img : s.img;
    var rightImg = (cand.missing[0] && cand.missing[0].img) ? cand.missing[0].img : s.img;
    // Lose Set-Komponenten im Korb (Keys), die beim Set-Kauf entfernt werden müssen (Swap, auch im Popup-Pfad)
    var overlapKeys = [];
    if (cartObj.items && s.comps) { var _ci = {}; s.comps.forEach(function (c) { _ci[c.id] = true; }); cartObj.items.forEach(function (it) { if (_ci[it.product_id] && !(it.properties && it.properties._bl_upsell)) { overlapKeys.push(it.key); _ci[it.product_id] = false; } }); }
    blSetCard(box,
      '<div class="bl-cart-hero__card">' +
        '<div class="bl-cart-hero__head">' +
          '<div class="bl-cart-hero__title">' + (BL_EN ? 'Complete the set.' : 'Mach’s komplett.') + '</div>' +
          (saveEuro ? '<span class="bl-cart-hero__save">' + (BL_EN ? 'Save ' : 'Spare ') + saveEuro + '</span>' : '') +
        '</div>' +
        '<div class="bl-cart-hero__body">' +
          '<div class="bl-cart-hero__visual">' +
            (leftImg ? '<span class="bl-cart-hero__hv"><img src="' + leftImg + '" alt="" decoding="sync"></span><span class="bl-cart-hero__plus">+</span>' : '') +
            '<span class="bl-cart-hero__hv"><img src="' + rightImg + '" alt="" decoding="sync"></span>' +
          '</div>' +
          '<div class="bl-cart-hero__info">' +
            '<div class="bl-cart-hero__text">' + (BL_EN ? ('Add <b>' + names + '</b> — as <b>' + s.title + '</b>.') : ('Nimm <b>' + names + '</b> dazu — als <b>' + s.title + '</b>.')) + '</div>' +
            '<div class="bl-cart-hero__price"><span class="bl-cart-hero__now">+' + euros(delta) + '</span>' +
              '<span class="bl-cart-hero__note">' + setNote(cand, delta) + '</span></div>' +
          '</div>' +
        '</div>' +
        // rem===0 -> Ein-Tap (mein Handler unten); rem===1 -> Popup nur für die eine fehlende Farbe
        '<button type="button" class="bl-cart-hero__cta"' + (cand.rem === 1 ? ' data-qa-open data-no-nav data-handle="' + s.handle + '" data-upsell="set:' + s.handle + '" data-delta="' + delta + '"' + (overlapKeys.length ? ' data-remove-keys="' + overlapKeys.join(',') + '"' : '') : '') + '>' + (BL_EN ? 'Get the set' : 'Set sichern') + '</button>' +
      '</div>');
    box.hidden = false;
    _blHero = { type: 'set', offer: s.handle, value: delta };
    blFireView(_blHero.type, _blHero.offer, _blHero.value);
  }

  // Ein-Tap-Set-Vervollständigung: Set-Variante aus den Korb-Farben ableiten, adden, lose Zeilen entfernen (Swap)
  function completeSet(cand) {
    var s = cand.set, overlapIds = {};
    s.comps.forEach(function (c) { overlapIds[c.id] = true; });
    return fetch('/cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' }).then(function (r) { return r.json(); }).then(function (cart) {
      return fetch('/products/' + s.handle + '.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (setP) {
        var want = {}, reduceLines = [], took = {};
        cart.items.forEach(function (it) {
          if (overlapIds[it.product_id] && !took[it.product_id] && !(it.properties && it.properties._bl_upsell)) {
            took[it.product_id] = true;   // 30.10.2026: zwei Po-Duschen im Korb -> nur eine ins Set, die andere bleibt
            // Nur EIN Stück in das Set übernehmen -> Menge um 1 reduzieren, Rest bleibt im Korb (nicht ganze Zeile löschen).
            reduceLines.push({ key: it.key, newQty: Math.max(0, (it.quantity || 1) - 1) });
            (it.options_with_values || []).forEach(function (ov) { want[String(ov.value || '').toLowerCase().trim()] = true; });
          }
        });
        var pick = null;
        setP.variants.forEach(function (v) {
          if (pick) return;
          var vals = [v.option1, v.option2, v.option3].filter(Boolean).map(function (x) { return String(x).toLowerCase().trim(); });
          var ok = true, w;
          for (w in want) { if (want.hasOwnProperty(w) && vals.indexOf(w) < 0) { ok = false; break; } }
          if (ok && v.available !== false) pick = v;
        });
        if (!pick) { for (var i = 0; i < setP.variants.length; i++) { if (setP.variants[i].available !== false) { pick = setP.variants[i]; break; } } }
        if (!pick) pick = setP.variants[0];
        return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: pick.id, quantity: 1, properties: { '_bl_upsell': 'set:' + s.handle } }) })
          .then(function () {
            if (!reduceLines.length) return;
            var updates = {}; reduceLines.forEach(function (r) { updates[r.key] = r.newQty; });
            return fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ updates: updates }) });
          })
          .then(function () { return blSetOrderAttr('set', s.handle); });  // order-level Attribut (überlebt Bundle-Zerlegung)
      });
    });
  }
  // Nach einem Hero-Upsell-Add NICHT die Seite neu laden: auf der PDP schließt reload() den Drawer
  // ("zurück zum Produkt"). Stattdessen den offenen Drawer in-place aktualisieren (wie das Quick-Add-Sheet).
  // Nur auf der /cart-Seite bleibt der klassische Reload.
  function blAfterUpsellAdd() {
    if (document.body.classList.contains('template-cart')) { window.location.reload(); return; }
    return fetch('?section_id=cart-helper').then(function (r) { return r.text(); }).then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var f = document.getElementById('AjaxCartForm'), nf = doc.getElementById('AjaxCartForm');
      if (f && nf) { f.innerHTML = nf.innerHTML; if (f.ajaxifyCartItems) f.ajaxifyCartItems(); }
      var s = document.getElementById('AjaxCartSubtotal'), ns = doc.getElementById('AjaxCartSubtotal');
      if (s && ns) s.innerHTML = ns.innerHTML;
      var cc = document.querySelector('[data-header-cart-count]'), nc = doc.querySelector('#AjaxCartForm [data-cart-count]');
      if (cc && nc) cc.textContent = nc.textContent;
      var sp = document.querySelector('cart-shipping-progress'); if (sp && sp.updateShippingProgress) sp.updateShippingProgress();
      var drawer = document.getElementById('site-cart'); if (drawer && f) drawer.classList.toggle('is-drawer-empty', f.querySelector('.cart-item') === null);
      document.querySelectorAll('[data-bl-hero] [aria-busy], [data-bl-hero2] [aria-busy]').forEach(function (b) { b.removeAttribute('aria-busy'); });
      refresh(); // Hero + „Passt zu deinem Korb" neu aus /cart.js (Hero verschwindet nach Annahme)
    }).catch(function () { window.location.reload(); });
  }

  // Mengen-Upsell-CTA: aktuelle Staffel-Variante durch die nächste ersetzen (Swap)
  document.addEventListener('click', function (e) {
    var cta = e.target.closest && e.target.closest('[data-bl-qty-cta]');
    if (!cta) return;
    e.preventDefault(); e.stopImmediatePropagation();
    if (cta.getAttribute('aria-busy') === 'true') return;
    cta.setAttribute('aria-busy', 'true');
    blAttrHold();
    blUpsellTrack('bl_upsell_add', 'qty', (cta.getAttribute('data-track') || 'qty'), null);
    var next = parseInt(cta.getAttribute('data-next'), 10), line = cta.getAttribute('data-line');
    fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: line, quantity: 0 }) })
      .then(function () { return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: next, quantity: 1, properties: { '_bl_upsell': 'qty:' + (cta.getAttribute('data-track') || 'waschstueck') } }) }); })
      .then(function () { return blSetOrderAttr('qty', (cta.getAttribute('data-track') || 'waschstueck')); })
      .then(blAfterUpsellAdd)
      .catch(function () { cta.removeAttribute('aria-busy'); });
  }, true);

  // Zubehör-Upsell-CTA: Variante mit _bl_upsell-Tracking hinzufügen
  document.addEventListener('click', function (e) {
    var cta = e.target.closest && e.target.closest('[data-bl-acc-cta]');
    if (!cta) return;
    e.preventDefault(); e.stopImmediatePropagation();
    if (cta.getAttribute('aria-busy') === 'true') return;
    cta.setAttribute('aria-busy', 'true');
    blAttrHold();
    var vid = parseInt(cta.getAttribute('data-vid'), 10), h = cta.getAttribute('data-h');
    blUpsellTrack('bl_upsell_add', 'accessory', h, null);
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: vid, quantity: 1, properties: { '_bl_upsell': 'accessory:' + h } }) })
      .then(function () { return blSetOrderAttr('accessory', h); })   // Reinigungs-Set ist ein Bundle -> Attribut nötig
      .then(blAfterUpsellAdd)
      .catch(function () { cta.removeAttribute('aria-busy'); });
  }, true);

  // Zubehör-REIHE („Passt zu deinem Korb"): Annahme nur mitzählen — Add + _bl_upsell-Tag laufen über das
  // Theme-Formular (Hidden-Input properties[_bl_upsell] in recommended-product-card.liquid). KEIN preventDefault!
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-bl-row-acc]');
    if (!btn) return;
    blUpsellTrack('bl_upsell_add', 'accessory', btn.getAttribute('data-bl-row-acc'), null);
  }, true);

  document.addEventListener('click', function (e) {
    var cta = e.target.closest && e.target.closest('.bl-cart-hero__cta');
    if (!cta || cta.hasAttribute('data-bl-qty-cta') || cta.hasAttribute('data-bl-acc-cta') || cta.hasAttribute('data-bl-h2set') || cta.hasAttribute('data-qa-open') || !cta.closest('[data-bl-hero]') || !_cand || _cand.rem !== 0) return; // rem===1 -> data-qa-open (bl-quickadd); data-bl-h2set -> Handler unten
    e.preventDefault(); e.stopImmediatePropagation();
    if (cta.getAttribute('aria-busy') === 'true') return;
    cta.setAttribute('aria-busy', 'true');
    blAttrHold();
    blUpsellTrack('bl_upsell_add', 'set', (_cand.set ? _cand.set.handle : ''), Math.max(0, _cand.set.price - (_cand.ovVal || 0)));
    completeSet(_cand).then(blAfterUpsellAdd).catch(function () { cta.removeAttribute('aria-busy'); });
  }, true);

  // Set-Vervollständigung als HIGHLIGHT 2 (rem===0 Ein-Tap) — eigener Handler, nutzt _blHero2Set
  document.addEventListener('click', function (e) {
    var cta = e.target.closest && e.target.closest('[data-bl-h2set]');
    if (!cta || !_blHero2Set) return;
    e.preventDefault(); e.stopImmediatePropagation();
    if (cta.getAttribute('aria-busy') === 'true') return;
    cta.setAttribute('aria-busy', 'true');
    blAttrHold();
    var s = _blHero2Set;
    blUpsellTrack('bl_upsell_add', 'set', s.set.handle, Math.max(0, s.set.price - (s.ovVal || 0)));
    completeSet(s).then(blAfterUpsellAdd).catch(function () { cta.removeAttribute('aria-busy'); });
  }, true);

  var _refreshT;
  function refresh() {
    clearTimeout(_refreshT);
    _refreshT = setTimeout(function () {
      updateHero(); // liest DOM — unabhängig von /cart.js
      fetch('/cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' })
        .then(function (r) { return r.json(); })
        .then(updateFromCart)
        .catch(function () {});
    }, 120);
  }

  // Cart-Mutationen abfangen (Add/Change/Update/Clear) — fetch + XHR
  var CART_RE = /\/cart\/(add|change|update|clear)(\.js)?/i;
  if (window.fetch) {
    var _fetch = window.fetch;
    window.fetch = function () {
      var a0 = arguments[0];
      var url = (a0 && a0.url) ? a0.url : a0;
      var p = _fetch.apply(this, arguments);
      if (CART_RE.test(String(url))) { try { p.then(refresh).catch(function () {}); } catch (e) {} }
      return p;
    };
  }
  var _open = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    if (CART_RE.test(String(url))) { this.addEventListener('load', refresh); }
    return _open.apply(this, arguments);
  };

  function init() {
    try { document.body.classList.add(blGetVar() === 'B' ? 'bl-ab-b' : 'bl-ab-a'); } catch (e) {}
    updateHero();
    fetch('/cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(updateFromCart)
      .catch(function () {});
    // Sicherheitsnetz: Korb-Zeilen-Änderungen (Theme-Re-Render) -> Hero neu berechnen
    try {
      var items = document.querySelector('.cart-items');
      if (items) {
        // Voller Refresh (nicht nur Hero): nach Theme-Re-Render (z.B. Löschen) Badge + Versand-Balken neu aus /cart.js -> gewinnt die Race
        var mo = new MutationObserver(function () { refresh(); });
        mo.observe(items, { childList: true, subtree: true });
      }
    } catch (e) {}
    // Reihe „Passt zu deinem Korb" lädt async + re-rendert -> Hero-Produkt bei jeder Änderung wieder ausblenden
    try {
      var recEl = document.getElementById('cart-recommendations');
      if (recEl) {
        var moR = new MutationObserver(function () { excludeHeroFromRow(); blFireRowViews(); });
        moR.observe(recEl, { childList: true, subtree: true });
      }
    } catch (e) {}
    // Drawer-Öffnung erkennen (#site-cart erhält Klasse 'active') -> Impressionen je Öffnung zählen (Dedupe-Reset + views)
    try {
      var drawerEl = document.getElementById('site-cart');
      if (drawerEl) {
        var _wasOpen = drawerEl.classList.contains('active');
        var moD = new MutationObserver(function () {
          var open = drawerEl.classList.contains('active');
          if (open && !_wasOpen) { setTimeout(blOnDrawerOpen, 60); } // kurz warten, bis Hero/Reihe gerendert sind
          _wasOpen = open;
        });
        moD.observe(drawerEl, { attributes: true, attributeFilter: ['class'] });
      }
    } catch (e) {}
  }
  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);

  // bfcache: beim Zurück-Button feuert DOMContentLoaded NICHT erneut -> Cart-Stand aktiv nachziehen,
  // damit die (PDP-)Versandbar sofort den echten Korb zeigt statt der eingefrorenen alten Seite.
  window.addEventListener('pageshow', function (e) {
    if (!e.persisted) return;
    fetch('/cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(updateFromCart)
      .catch(function () {});
  });
})();

/* 31.10.2026: Der fixe Fußbereich ändert seine Höhe (Rabattcode, Hinweise). Scroll-Platz im Drawer folgt ihm,
   damit der letzte Inhalt immer frei gescrollt werden kann. CSS dazu in new-custom.css. */
(function () {
  var drawer = document.getElementById('site-cart'), foot = document.getElementById('AjaxCartSubtotal');
  if (!drawer || !foot || !window.ResizeObserver) return;
  new ResizeObserver(function () {
    if (foot.offsetHeight) drawer.style.setProperty('--bl-cart-foot', foot.offsetHeight + 'px');
  }).observe(foot);
})();
